export default __webpack_public_path__ + "static/media/FlatGenericFullSize.2019c24c.png";